import { config } from "../config";
import { PublicClientApplication, Configuration } from '@azure/msal-browser';

const msalConfig: Configuration = {
  auth: {
    ...config.auth,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
